import {graphql} from "gatsby";
import {FC, PropsWithChildren} from "react";
import Footer from "../footer/footer";
import Header from "../header/header";
import StickyCallToAction from "../sticky-call-to-action/sticky-call-to-action";

import "normalize.css";
import "../../styles/basics.scss";
import "../../styles/fonts.scss";
import "../../styles/typography.scss";

export interface LayoutProps extends Queries.LayoutFragment {
  overrides: Queries.StickyCallToActionOverrideFragment;
  page?: Queries.DatoCmsPage;
}

const Layout: FC<PropsWithChildren<LayoutProps>> = ({
  children,
  siteWide,
  overrides,
  page,
}) => {
  return (
    siteWide && (
      <div className={`layout-template-${page?.template ?? 'default'}`}>
        <Header {...siteWide} />
        {children}
        <Footer {...siteWide} />
        <StickyCallToAction
          stickyCallToAction={
            overrides?.stickyCallToAction?.length
              ? overrides.stickyCallToAction
              : siteWide.stickyCallToAction
          }
        />
      </div>
    )
  );
};

export default Layout;

export const query = graphql`
  fragment Layout on Query {
    siteWide: datoCmsSitewide(locale: $locale, fallbackLocales: ["en"]) {
      ...Header
      ...Footer
      ...StickyCallToAction
    }
  }
`;
